import React, { Component } from 'react'

class Input extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  render () {
    const { fieldData } = this.props
    const { id, type, placeholder, value, readOnly, maxLength, pattern, disabled } = fieldData

    const handler = fieldData.handler ? fieldData.handler : this.handleChange 

    return (
      <input
        className='input'
        type={type}
        placeholder={placeholder}
        id={id}
        value={value || ''}
        onChange={handler}
        readOnly={readOnly}
        maxLength={maxLength}
        pattern={pattern}
        disabled={disabled}
      />
    )
  }

  handleChange (event) {
    const { fieldData, store } = this.props
    const { name } = fieldData
    store.handleChange(event.target.value, name)
  }
}

export default Input



// WEBPACK FOOTER //
// ./src/components/generic/Input.js